/* 뷰어 */

import {
  getVacationMap,
  getOtWorkMap,
  getScheduleMap,
  getRewardMap,
  getAttendMap,
  getCancelVacationMap,
  getCancelRewardMap,
  getBizTripAppDet,
} from '@/api/application';

const viewer = {
  state: {
    appMapData: {},
  },
  getters: {
    GET_APPL_MAP_PARAM(state, getters) {
      const appMapData = state.appMapData;
      return {
        ...appMapData,
        ...getters.GET_ELA_APPL_PARAM,
      };
    },
    GET_APP_MAP_DATA(state) {
      return state.appMapData;
    },

    GET_MAP_REASON(state) {
      return state.appMapData.reason || '-';
    },
  },
  mutations: {
    SET_APP_MAP_DATA(state, data) {
      state.appMapData = data;
    },
  },
  actions: {
    /**
     * 근태 - 상세 데이터 조회
     */
    async FETCH_VACATION_MAP({ commit }, param) {
      const response = await getVacationMap(param);
      commit('SET_APP_MAP_DATA', response.data.data);
    },
    /**
     * 연장근무 - 상세 데이터 조회
     */
    async FETCH_OT_WORK_MAP({ commit }, param) {
      const response = await getOtWorkMap(param);
      commit('SET_APP_MAP_DATA', response.data.data);
    },

    /**
     * 근무스케줄 - 상세 데이터 조회
     */
    async FETCH_SCHEDULE_MAP({ commit }, param) {
      const response = await getScheduleMap(param);
      commit('SET_APP_MAP_DATA', response.data.data);
    },

    /**
     * 보상휴가 - 상세 데이터 조회
     */
    async FETCH_REWARD_MAP({ commit }, param) {
      const response = await getRewardMap(param);
      commit('SET_APP_MAP_DATA', response.data.data);
    },

    /**
     * 출퇴근변경신청 - 상세 데이터 조회
     */
    async FETCH_ATTEND_MAP({ commit }, param) {
      const response = await getAttendMap(param);
      commit('SET_APP_MAP_DATA', response.data.data);
    },

    /**
     * 근태취소신청 - 상세 데이터 조회
     */
    async FETCH_CANCEL_VACATION_MAP({ commit }, param) {
      const response = await getCancelVacationMap(param);
      commit('SET_APP_MAP_DATA', response.data.data);
    },

    /**
     * 보상취소신청 - 상세 데이터 조회
     */
    async FETCH_CANCEL_REWARD_MAP({ commit }, param) {
      const response = await getCancelRewardMap(param);
      commit('SET_APP_MAP_DATA', response.data.data);
    },

    /**
     * 출장신청 - 상세 데이터 조회
     */
    async FETCH_BIZ_TRIP_MAP({ commit }, param) {
      // 1. api 호출
      const response = await getBizTripAppDet(param);
      const responseData = response.data.data;

      // 2. 동적컬럼 추출
      // ** 고정컬럼 제외하고 필터링
      const dcols = responseData.col.filter(
        item =>
          item.columnId !== 'DATE' &&
          item.columnId !== 'TITLE' &&
          item.columnId !== 'SABUN' &&
          item.columnId !== 'SABUN_NOTE',
      );

      const sabunNoteCol = responseData.col.find(
        item => item.columnId === 'SABUN_NOTE',
      );

      // 3. 리턴 데이터 셋팅
      const mapData = {
        bizTripDynamicCols: dcols,
        sabunNoteCol: sabunNoteCol,
        bizTripData: responseData.data, // type :: {TITLE:'', DATE: '', SABUN: ''...}
        bizTripJoiner: responseData.emp, // type :: [{sabun: '', name: ''}, ...]
      };

      // 4. mutation 호출
      commit('SET_APP_MAP_DATA', mapData);
    },
  },
};

export default viewer;
